import env from "../env"
import {vars} from "../config"

export default currentLang => {
  return Array.reduce(
    env.LANGUAGES,
    (acc, l) => {
      if (l === currentLang) {
        return acc
      } else {
        return {...acc, [l]: vars.languages[l]}
      }
    },
    {}
  )
}



// WEBPACK FOOTER //
// ./src/utils/otherLanguages.js